export const GET_SHOP_DIAMOND = "GET_SHOP_DIAMOND";
export const GET_SELLER_SHOP_DIAMOND = "GET_SELLER_SHOP_DIAMOND";
export const CREATE_SHOP_DIAMOND = "CREATE_SHOP_DIAMOND";
export const EDIT_SHOP_DIAMOND = "EDIT_SHOP_DIAMOND";
export const DELETE_SHOP_DIAMOND = "DELETE_SHOP_DIAMOND";

export const OPEN_DIAMOND_SHOP_DIALOG = "OPEN_DIAMOND_SHOP_DIALOG";
export const CLOSE_DIAMOND_SHOP_DIALOG = "CLOSE_DIAMOND_SHOP_DIALOG";
